import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
// import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import ReportBox from '../atoms/ComponentBox/ReportBox';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const DailyReport = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const permissions = useSelector(selectPermissions);
    const hasModulePermission = (moduleName) => {
        const modulePermission = permissions.find(
            permission => permission.ModuleName === moduleName
        );

        if (!modulePermission) return false;

        return (
            modulePermission.AddRec === "1" ||
            modulePermission.EditRec === "1" ||
            modulePermission.DeleteRec === "1" ||
            modulePermission.ViewRec === "1"
        );
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        {hasModulePermission("Daily Summary Report") && (
                            <ReportBox
                                permissions={permissions}
                                link={{ pathname: '/dailysummaryreport' }}
                                title="Daily Summary Report"
                            />
                        )}

                        {hasModulePermission("Audit Trail") && (
                            <ReportBox
                                link={{ pathname: '/audit-report' }}
                                permissions={permissions}
                                title="Audit Trail"
                            />
                        )}

                        {hasModulePermission("Month Wise Bed Availability") && (
                            <ReportBox
                                permissions={permissions}
                                link={{ pathname: '/bedcategorysummary' }}
                                title="Month Wise Bed Availability"
                            />
                        )}

                        {hasModulePermission("Bed Report Calendar") && (
                            <ReportBox
                                permissions={permissions}
                                // link={{ pathname: "/bedreporttable" }}
                                link={{ pathname: "/generatecalender" }}
                                title="Bed Report Calendar"
                            />
                        )}

                        {hasModulePermission("Daily Task Report") && (
                            <ReportBox
                                permissions={permissions}
                                // link={{ pathname: "/bedreporttable" }}
                                link={{ pathname: "/dailytaskreport" }}
                                title="Daily Task Report"
                            />
                        )}
                        {hasModulePermission("Daily Task Report") && (
                            <ReportBox
                                permissions={permissions}
                                // link={{ pathname: "/bedreporttable" }}
                                link={{ pathname: "/operations/summaryreport" }}
                                title="Daily Wise Task Entry"
                            />
                        )}

                        {hasModulePermission("Enquiry Report") && (
                            <ReportBox
                                permissions={permissions}
                                link={{ pathname: '/enquiry-report' }}
                                title="Enquiry Report"
                            />
                        )}
                         {hasModulePermission("Attendance Report") && (
                            <ReportBox
                                permissions={permissions}
                                link={{ pathname: '/attendance-report' }}
                                title="Attendance Report"
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
export default DailyReport;
